// import BookingUpdatersReceipt from "../features/booking/BookingUpdatersReceipt";

// import {progress} from "../data/progress/feature.progress.svelte.js";
import {mount} from "svelte";
// import AppConfig from "../AppConfig.js";
// import {ENVIRONMENT_DEVARANA} from "../AppConstants.js";
import WidgetCalendar from "../widgets/calendar_home/Widget.CalendarHome.svelte";
import RoutingUtil from "./RoutingUtil.js";
import {widgets} from "../data/widgets/feature.widgets.svelte.js";
import {progress} from "../data/progress/feature.progress.svelte.js";
import {ENVIRONMENT_DEN_ILP, ENVIRONMENT_DEVARANA, ENVIRONMENT_RIDDERRODE, ENVIRONMENT_SWEETLAKE} from "../AppConstants.js";
import AppConfig from "../AppConfig.js";
import * as actions_progress from "../data/progress/actions_progress.svelte.js";
import URLUtil from "./URLUtil.js";
import WidgetPageAccount from "../widgets/page_account/Widget.PageAccount.svelte";

class WidgetUtil {

  static mountWidgets = () => {
    widgets.bIsThisAWidgetBuildInsteadOfTheShop = true;

    // dynamic mounting - als je id in de html staat die matcht dan app x laden
    const appMappings = [
      //{id: 'AppComponents', component: AppComponents},
      {id: 'widget-calendar', component: WidgetCalendar},
      {id: 'widget-page-account', component: WidgetPageAccount},
    ];

    appMappings.map(({id, component}) => {
      const target = document.getElementById(id);

      // Only mount if the target exists and is empty
      if ( target && target.children.length === 0 )
      {
        return mount(component, {target});
      }
      return null;
    });
  }

  static async performWidgetsSharedBootSequence(fnCallback = false)
  {
    // console.log('performWidgetsSharedBootSequence');

    if ( widgets.bWasWidgetsSharedBootSequenceStarted === true )
    {
      console.log('performWidgetsSharedBootSequence gestopt omdat die al vanuit een andere widget liep');

      if ( typeof fnCallback === "function" )
      {
        fnCallback();
      }

      return;
    }

    let sEnvFromHost = RoutingUtil.getEnvFromHost();
    progress.sEnvironmentID = sEnvFromHost;

    switch ( sEnvFromHost )
    {
      case ENVIRONMENT_DEVARANA:
        progress.bIsEnvDevarana = true;
        progress.bIsEnvDenIlp = false;
        progress.bIsEnvRidderrode = false;
        progress.bIsEnvSweetLake = false;
        break;
      case ENVIRONMENT_DEN_ILP:
        progress.bIsEnvDevarana = false;
        progress.bIsEnvDenIlp = true;
        progress.bIsEnvRidderrode = false;
        progress.bIsEnvSweetLake = false;
        break;
      case ENVIRONMENT_RIDDERRODE:
        progress.bIsEnvDevarana = false;
        progress.bIsEnvDenIlp = false;
        progress.bIsEnvRidderrode = true;
        progress.bIsEnvSweetLake = false;
        break;
      case ENVIRONMENT_SWEETLAKE:
        progress.bIsEnvDevarana = false;
        progress.bIsEnvDenIlp = false;
        progress.bIsEnvRidderrode = false;
        progress.bIsEnvSweetLake = true;
        break;
    }

    window.console.log('BOOT environment:', sEnvFromHost);

    AppConfig.loadConfig(sEnvFromHost); // normaal

    // Als laatste nog de error logging regelen
    let bIsReportingError = false;

    window.onerror = function (msg, url, lineNo, columnNo, error) {
      if ( bIsReportingError ) return;
      bIsReportingError = true;

      const sBaseUrl = URLUtil.getCurrentPageRelativeLinkWithoutAction();
      let sTargetUrl = sBaseUrl + "/resdata/logcallWidgets/";

      fetch(sTargetUrl, {
        method: 'POST',
        body: JSON.stringify({msg, url, lineNo, columnNo, error})
      }).finally(() => {
        bIsReportingError = false;
      });

      return true;  // Prevents the default error handler
    };

    if ( 1 === 2 )
    {
      setTimeout(() => {
        throw new Error("Test widget error - Something went wrong!");
      }, 1000);
    }

    await actions_progress.apiCallRequestWidgetData();

    if ( typeof fnCallback === "function" )
    {
      fnCallback();
    }
  }


  static getEnvFromHost = (sHostName = '') => {
    if ( sHostName === '' )
    {
      sHostName = window.location.hostname;
    }

    if ( AppConfig.aHostToEnvMap[sHostName] )
    {
      return AppConfig.aHostToEnvMap[sHostName];
    }

    return ENVIRONMENT_DEVARANA;
  }

  static appendWebshopStyleSheetToPage = (fnCallbackAfterLoad = () => {
  }) => {
    return new Promise((resolve) => {
      const sDefaultTheme = 'is-denilp';
      const sHost = window.location.hostname;

      if ( sHost === 'localhost' )
      {
        progress.bIsLocal = true;
      }

      let sEnv = RoutingUtil.getEnvFromHost(sHost);

      const aHostToThemeMap = {
        "dvr": "is-devarana",
        "di": "is-denilp",
        "rr": "is-rr",
        "sl": "is-sl"
      };

      if ( aHostToThemeMap[sEnv] )
      {
        document.body.classList.add(aHostToThemeMap[sEnv]);
      }
      else
      {
        document.body.classList.add(sDefaultTheme);
      }

      // CSS file toevoegen
      var sBasePath = '../_resources/app/client/css/';

      if ( sHost === 'localhost' )
      {
        sBasePath = '../public/_resources/app/client/css/';
      }

      let stylesheet = '';

      // if ( sHost === 'localhost' )
      // {
      // dev-server proxy heeft public/ prefix nodig
      // stylesheet = "public/_resources/app/client/css/webshop-den-ilp.css?" + Date.now();
      // }
      // else
      // {
      const styles = {
        "dvr": sBasePath + "webshop-devarana.css?" + Date.now(),
        "di": sBasePath + "webshop-den-ilp.css?" + Date.now(),
        "rr": sBasePath + "webshop-ridderrode.css?" + Date.now(),
        "sl": sBasePath + "webshop-sweetlake.css?" + Date.now(),
      };

      // Brands that use the new base+brand architecture
      const aBrandsWithBase = ["sl"];

      stylesheet = styles[sEnv] || "public/_resources/app/client/css/webshop-den-ilp.css?" + Date.now();

      const fnLoadCSS = (sHref) => {
        return new Promise((fnResolveCSS) => {
          const link = document.createElement("link");
          link.rel = "stylesheet";
          link.href = sHref;
          link.onload = fnResolveCSS;
          document.head.appendChild(link);
        });
      };

      if ( aBrandsWithBase.includes(sEnv) )
      {
        document.documentElement.dataset.brand = sEnv;
        const sBaseHref = sBasePath + "webshop-base.css?" + Date.now();

        fnLoadCSS(sBaseHref)
          .then(() => fnLoadCSS(stylesheet))
          .then(() => {
            resolve();
            if ( typeof fnCallbackAfterLoad === "function" ) fnCallbackAfterLoad();
          });
      }
      else
      {
        fnLoadCSS(stylesheet).then(() => {
          resolve();
          if ( typeof fnCallbackAfterLoad === "function" ) fnCallbackAfterLoad();
        });
      }
    });
  }
}

export default WidgetUtil;